import { useState } from "react";
import { Channel } from "../../api/getChannels";
import ChannelSingle from "../../components/Channel/ChannelSingle/ChannelSingle";
import PageHeader from "../../components/hoc/PageHeader/PageHeader";
import PageView from "../../components/hoc/PageView/PageView";
import { useUserContext } from "../../components/hoc/UserContext/UserContext";

interface ChannelUserProps {}

const ChannelUser = (props: ChannelUserProps) => {
  const { user } = useUserContext();
  console.log("🚀 ~ file: ChannelUser.tsx ~ line 12 ~ ChannelUser ~ user", user)
  const [selectedChannel] = useState<Channel | undefined>(user && user.channels.length ? user.channels[0] : undefined);

  return (
    <PageView>
      {!user?.channels.length ? (
        <h1>No channels found</h1>
      ) : (
        <>
          <PageHeader>
            {/* {user.channels.length > 1 && (
              <FormControl variant="outlined">
                <InputLabel htmlFor="channel">Channel</InputLabel>
                <Select
                  native
                  value={selectedChannel}
                  onChange={(event) => {
                    console.log("🚀 ~ file: ChannelUser.tsx ~ line 32 ~ ChannelUser ~ event.target.value", event.target.value)
                    setSelectedChannel(event.target.value as string);
                  }}
                  label="Channel"
                  inputProps={{
                    name: 'channel',
                    id: 'channel',
                  }}
                >
                  {user.channels.map(channel => (
                    <option value={channel.id}>{channel.channelName}</option>
                  ))}
                </Select>
              </FormControl>
            )} */}

        </PageHeader>
        <ChannelSingle
          data={selectedChannel}
        />
      </>
      )}
    </PageView>
  )
};

export default ChannelUser;